import styled from "styled-components";

const Image = styled.img`
  max-width: 100%;
`;

export { Image };
